<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-news infinite-list">

    <page-title :title="'Piwopedia'" :back="true"></page-title>

    <wiki-segment></wiki-segment>

    <ion-searchbar mode="md"
                   placeholder="Wyszukaj hasło"
                   @input="handleSearch($event)">
    </ion-searchbar>

    <div v-for="(item,index) in wikis" :key="item.slug + index">
      <item-wiki
          :index="index+1"
          :slug="item.slug"
          :category_name="item.category_name"
          :icon="item.icon"
          :title="item.title"
          :excerpt="item.excerpt"
          :description="item.description">
      </item-wiki>
    </div>

    <p v-if="wikis.length === 0" class="text-center">Brak wyników.</p>

    <ion-button v-if="last_page > page"
                mode="ios"
                expand="block"
                class="mb-10"
                @click="loadMore"
                :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Załaduj więcej</span>
    </ion-button>

  </div>
</template>

<script>
import {mapState} from 'vuex';
import infiniteList from '@/mixins/infiniteList';
import PageTitle from '@/components/PageTitle.vue';
import ItemWiki from '@/items/ItemWiki';
import WikiSegment from '@/navs/WikiSegment';

export default {
  name: 'WikiIndex',
  mixins: [infiniteList],
  components: {PageTitle, ItemWiki, WikiSegment},
  computed: {
    ...mapState({
      loading: state => state.wikis.loading,
      wikis: state => state.wikis.data,
      categories: state => state.global.categories.wikis,
      page: state => state.wikis.page,
      last_page: state => state.wikis.last_page
    })
  },
  // created() {
  //   this.$root.$on('intiniteList', (payload) => {
  //     this.$store.dispatch('wikis/KNOWLEDGE_WIKIS_SET_PAGE', false)
  //     this.getWikis();
  //   });
  // },
  // beforeDestroy() {
  //   this.$root.$off("intiniteList");
  // },
  mounted() {
    this.loadMore()
  },
  methods: {
    async getWikis() {
      // fetch global wikis categories (id 5)
      if (!this.categories.length) {
        await this.$store.dispatch('GLOBAL_CATEGORIES_REQUEST', 5)
      }
      // dispatch wikis after category is set
      this.$store.dispatch('wikis/KNOWLEDGE_WIKIS_REQUEST')
    },
    loadMore(){
      this.$store.dispatch('wikis/KNOWLEDGE_WIKIS_SET_PAGE', false).then(() => {
        this.getWikis();
      })
    },
    handleSearch(e) {
      // handle input with simple debounce
      if (this.timeout) clearTimeout(this.timeout);
      let payload = {'search': e.target.value};
      this.timeout = setTimeout(() => {
        this.$store.dispatch('wikis/KNOWLEDGE_WIKIS_SET_SEARCH', payload);
      }, 200);
    }
  }
}
</script>

<style lang="scss" scoped>
ion-list {
  margin: 0;
  background: none;
}
</style>
